import { Box, Typography, useTheme } from "@mui/material";
import patterbackground from "../../../assets/pattern3.svg";
import { tokens } from "../../../theme";

interface Props {
  step: 1 | 2 | 3;
}

const STEPS = ["Basic Info", "Unit Details", "Supplier & Finance"];

export default function StepHeader({ step }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const circleSx = (stepNum: number) => ({
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: step >= stepNum ? colors.primary[900] : "transparent",
    color: step >= stepNum ? colors.primary[400] : colors.primary[900],
    border: step < stepNum ? "1.5px solid rgba(255,255,255,0.7)" : "none",
    display: "grid",
    placeItems: "center",
    fontWeight: 700,
    fontSize: "0.82rem",
    zIndex: 2,
    flexShrink: 0,
  });

  const trackSx = {
    position: "relative" as const,
    flex: 1,
    height: "4px",
    backgroundColor: "rgba(255,255,255,0.3)",
    borderRadius: "999px",
    overflow: "hidden",
    mx: "-1px",
  };

  const fillWidth = (trackIndex: 1 | 2): string => {
    if (trackIndex === 1) {
      if (step === 1) return "50%";
      return "100%";
    }
    if (step <= 1) return "0%";
    if (step === 2) return "50%";
    return "100%";
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${patterbackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        px: 4,
        py: 3,
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 500, mx: "auto" }}>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Box sx={circleSx(1)}>1</Box>

          <Box sx={trackSx}>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: fillWidth(1),
                backgroundColor: colors.primary[900],
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>

          <Box sx={circleSx(2)}>2</Box>

          <Box sx={trackSx}>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: fillWidth(2),
                backgroundColor: colors.primary[900],
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>
          <Box sx={circleSx(3)}>3</Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
          {STEPS.map((label, i) => {
            const stepNum = (i + 1) as 1 | 2 | 3;
            const isActive = step === stepNum;
            return (
              <Typography
                key={label}
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: isActive ? 700 : 400,
                  color: isActive
                    ? colors.primary[900]
                    : "rgba(255,255,255,0.65)",
                  textAlign: i === 0 ? "left" : i === 2 ? "right" : "center",
                  flex: 1,
                }}
              >
                {label}
              </Typography>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}